import { CustomHookService } from 'app/ViewModules/shared-services/custom-hook/custom-hook.service';
import { NewBusinessAppSettings } from './../../Newbusiness/newbusiness-configs/newbusiness-app-settings.config';
import { filter } from 'rxjs/operators';
import { WorkqueueService } from './../../../BaseFramework/core/http/workqueue.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorDO } from './../../../BaseFramework/shared/models/error.model';
import { MetadataService } from '../../../BaseFramework/core/http/metadata.service';
import { differenceInCalendarDays, setHours } from 'date-fns';

import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { DisabledTimeFn } from 'ng-zorro-antd/date-picker/standard-types';
import { DataTransformService } from 'app/ViewModules/shared-services';

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}


@Component({
  selector: 'app-submission-data',
  templateUrl: './submission-data.component.html',
  styleUrls: ['./submission-data.component.scss']
})
export class SubmissionDataComponent implements OnInit {
  productData = []
  _currentComponentName = "SubmissionDataComponent"
  planTypeLookup = [];
  packageTypeLookup = [];
  fakeValidationStatus;
  policyBasicDetailsDataMap = {};
  // termType = "FIXED"

  displayField = 'TERM';

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private workqueueService: WorkqueueService,
    public appMetadataHandler: AppMetadataHandler,
    public newBusinessAppSettings: NewBusinessAppSettings,
    public customHookService: CustomHookService,
    private msgService: NzMessageService,    
    private metadataService: MetadataService,
    private dataTransformService: DataTransformService) { }

  public currencyOptions = {
    prefix: this.appMetadataHandler.baseCurrencyPREFIX,
    thousands: this.appMetadataHandler.THOUSANDS_SEPARATOR,
    decimal: this.appMetadataHandler.DECIMAL_SEPARATOR,
    align: this.appMetadataHandler.currencyAlignment
  }

  //Declaraions which might need developer input
  SubmissionDataForm: FormGroup
  SUBMISSIONDATAFORMNAME = "submissionDataForm"
  lookupsToBind = ['relationCd', 'currencyCd', 'genderCd', 'citizenshipCd', 'provinceCd', 'cityCd', 'identityCd', 'purposeOfInsuranceCd', 'productOptionCd' , 'NBUChannelList'];

  selectorOfThisComponent = 'app-submission-data'
  parentEvent$
  UIMetadataMap = {
    "BasePlan": {
      Metadata: []
    }
  }
  productCd = null;
  policyBasicDetailsMetadata = [];

  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE   
   */

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Output() changedField = new EventEmitter<any>() 
  @Input() type: string;
  @Input() transactionState: string;
  @Input() DOName: string;
  @Input() proposalType: String;
  @Input() configData;
  @Input() product;
  @Input() productFamilyCd;
  @Output() mandatoryCoveragesEmitter = new EventEmitter<any>()
  @Output() basePlanRefreshEmitter = new EventEmitter<any>()
  @Output() mandatoryCoveragesRefreshEmitter = new EventEmitter<any>()
  @Output() additionalCoveragesRefreshEmitter = new EventEmitter<any>()
  @Output() policyPackageType = new EventEmitter<any>();


  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
  };

  get inputDataForEdit() {
    return this._inputDataForEdit;
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.UItoServerTransform)
  }
  EmitChangedField(data){
    this.changedField.emit(data);
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      let componentOutput = {
        data: this.policyBasicDetailsDataMap,
        productCd: this.product ? this.product.productId : null,
        productFamilyCd: this.productFamilyCd
      }
      const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {

        if (this.appMetadataHandler.featureFlags.enableDynamicRendering) {
          this.EmitComponentOutput(componentOutput)
        } else {
          let validationResult = this.validateOutput(this.SubmissionDataForm)
          if (!validationResult.isInvalid)
            this.EmitComponentOutput(this.SubmissionDataForm)
          else {
            this.EmitComponentOutput(validationResult)
          }
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }


  validateOutput(o: FormGroup): ValidationOutput {
    this.commonUtilty.markAllFieldDirty(o);

    let validationOutput: ValidationOutput = {
      isInvalid: null,
      errorDOs: []
    }
    validationOutput.errorDOs = this.checkInvalidAndEmptyFields(o, this.getCurrentComponentName())

    if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
      validationOutput.isInvalid = true;
    }
    else {
      validationOutput.isInvalid = false;
    }

    return validationOutput
  }

  // Front end error list
  errorList: any = [];
  genericSubject$
  policyTerm = null;
  env = environment;
  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.getCurrentComponentName()}></${this.getCurrentComponentName()}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.getCurrentComponentName()} (componentOutput)='doSomethingOnDataReceived()'></${this.getCurrentComponentName()}>`, consoleStyle)
      console.groupEnd();
    }

    this.initializeClientSearchForm(this._inputDataForEdit, this.DOName)
    this.getLookupData();

    if (this.appMetadataHandler.featureFlags.enableDynamicRendering) {
      this.getSelectedProductRenderForm();
    } else {

      if (this._inputDataForEdit) {
        if (this.DOName) {
          this.initializeClientSearchForm(this._inputDataForEdit, this.DOName)
          let DO = this.commonUtilty.getDO(this._inputDataForEdit) || {}
          this.policyTerm = DO['policyTerm'] || null;
          if (this.currencyLookup && this.currencyLookup.length && this.currencyLookup.length > 0) {
            this.currencyLookup.forEach(currencyObj => {
              if (DO['currencyCd'] === currencyObj.lookupKey)
                this.SubmissionDataForm.get('currencyType').setValue(currencyObj.lookupKey);
            })
          }
          if(DO['currencyCd']) this.appMetadataHandler.setCurrency(DO['currencyCd']);
          this.clearCoveragesLookup();
          this.fetchCoverages(DO['baseProductCd'])
          this.setPlanAndPackages(DO);

        }
        else
          throw "DOName not found for " + this.getCurrentComponentName + "Component"
      }

      this.fetchProducts();
      this.clearCoveragesLookup();
      this.fetchCoverages(this.product? this.product.productId: null)

      this.onChanges();
    }
    this.subscribeToParentEvent();
  }

  /**
   * Form Trasactions
   */

  FormFieldNameMap = {
    eventType: "Event Type",
    eventDate: "Event Date",
    retypeEventDate: "Retype Event Date",
    eventTime: "Event Time",
    retypeEventTime: "Retype Time",
    causeOfDeath: "Cause of Death",
    intimationDt: "Intimation Date",
    receivedDt: "Received Date",
  }

  private getLookupData() {
    this.lookup$['currencyCd'].subscribe(lookup => {
      this.currencyLookup = lookup;
      // this.currencyLookup = cur
    });
    this.lookup$['productOptionCd'].subscribe(lookup => {
      this.planTypeLookup = lookup;
    });
    // this.lookup$['productOptionCd'].subscribe(lookup => {
    //   this.packageTypeLookup = lookup;
    //   console.log("packageTypeLookup", JSON.stringify(this.packageTypeLookup));
    // });
  }

  initializeClientSearchForm(data?, DOName?) {
    // if (Array.isArray(data)) {
    //   data = null
    //   console.error("Form in " + this.getCurrentComponentName() + " is getting inputForEdit as Array. It is expecting Object or null.")
    // }
    let payload = data || {}
    let DO
    if (data && !DOName)
      DO = this.commonUtilty.getDO(data) || {}
    else
      DO = payload[DOName] || {}

    this.SubmissionDataForm = this.fb.group({
      masterPolicyNo: this.validationUtilService.setValidationsForFormControl('masterPolicyNo', this.SUBMISSIONDATAFORMNAME, DO['parentPolicyNum']),
      praposalSubmissionDate: this.validationUtilService.setValidationsForFormControl('praposalSubmissionDate', this.SUBMISSIONDATAFORMNAME, DO['proposalEntryDt']),
      signedDate: this.validationUtilService.setValidationsForFormControl('signedDate', this.SUBMISSIONDATAFORMNAME, this.commonUtilty.serverDOtoUIDODate(DO['proposalSignedDt'])),
      campaignCode: this.validationUtilService.setValidationsForFormControl('campaignCode', this.SUBMISSIONDATAFORMNAME, DO['promoCd']),
      planType: null,
      packageType: null,
      productType: this.validationUtilService.setValidationsForFormControl('productType', this.SUBMISSIONDATAFORMNAME, DO['baseProductCd']),
      currencyType: this.validationUtilService.setValidationsForFormControl('currencyType', this.SUBMISSIONDATAFORMNAME, DO['currencyCd']),
      purposeOfInsuranceType: this.validationUtilService.setValidationsForFormControl('purposeOfInsuranceType', this.SUBMISSIONDATAFORMNAME, DO['purposeOfInsuranceCd']),
      // sumInsured: this.validationUtilService.setValidationsForFormControl('sumInsured', this.SUBMISSIONDATAFORMNAME, DO['sumInsured']),
      entryDate: this.validationUtilService.setValidationsForFormControl('entryDate', this.SUBMISSIONDATAFORMNAME, this.commonUtilty.serverDOtoUIDODate(DO['proposalEntryDt'])),
      receivedDate: this.validationUtilService.setValidationsForFormControl('receivedDate', this.SUBMISSIONDATAFORMNAME, this.commonUtilty.serverDOtoUIDODate(DO['proposalReceivedDt'])),
      inceptionDate: this.validationUtilService.setValidationsForFormControl('inceptionDate', this.SUBMISSIONDATAFORMNAME, this.commonUtilty.serverDOtoUIDODate(DO['policyCommencementDt'])),
      expiryDate: this.validationUtilService.setValidationsForFormControl('expiryDate', this.SUBMISSIONDATAFORMNAME, this.commonUtilty.serverDOtoUIDODate(DO['policyExpiryDt'])),
      anniversaryDt: this.validationUtilService.setValidationsForFormControl('anniversaryDt', this.SUBMISSIONDATAFORMNAME, this.commonUtilty.serverDOtoUIDODate(DO['anniversaryDt'])),
      dueDate: this.validationUtilService.setValidationsForFormControl('dueDate', this.SUBMISSIONDATAFORMNAME, this.commonUtilty.serverDOtoUIDODate(DO['policyExpiryDt'])),
      term: this.validationUtilService.setValidationsForFormControl('term', this.SUBMISSIONDATAFORMNAME, DO['policyTerm']),
      termType: DO['termTypeCd'] ? DO['termTypeCd'] : 'FIXED',
      coverType: DO['sunInsuredTypeCd']
    });
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.SUBMISSIONDATAFORMNAME
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }

  productSubject$
  getSelectedProductRenderForm() {
    console.log("selected product is", JSON.stringify(this.product));
    if (this.product)
      this.actionablesOnProductSelection(this.product.productId);
  }

  public checkInvalidAndEmptyFields(Form: FormGroup, componentName) {
    let invalidFields = [];
    if (!Form.valid) {
      for (const i in Form.controls) {

        let controlName = this.commonUtilty.getControlName(Form.controls[i])
        let validationErrorList = this.validationUtilService.getUIErrorList(this.SubmissionDataForm.get(controlName), this.SUBMISSIONDATAFORMNAME)
        if (Form.controls[i].status === 'INVALID') {
          validationErrorList.forEach(validationError => {
            let errorDO = new ErrorDO();
            errorDO.errorMsg = validationError;
            errorDO.fieldName = controlName;
            errorDO.fieldNameDescription = this.FormFieldNameMap[controlName]
            errorDO.componentName = componentName;
            invalidFields.push(errorDO)
          })
        }
      }
    }
    return invalidFields;
  }

  fetchProducts() {
    this.workqueueService.fetchProducts(this.productFamilyCd)
      .subscribe(jsonResp => {
        if (jsonResp && jsonResp.length) {
          jsonResp.forEach((criteria: any) => {
            if (criteria && Object.keys(criteria).length) {
              this.productData.push(criteria);
            } else {
              this.productData = [];
            }
            // let searchCriteriaDO = new SearchAPIMetaDataDO();
            // searchCriteriaDO.key = criteria.attributeName;
            // searchCriteriaDO.keyDescription = criteria.description;
            // searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
            // searchCriteriaDO.lookupName = criteria.attr.ibuteLookupCd;
            // searchCriteriaDO.lookup = [];
            // searchCriteriaDO.enable = true;
            // searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
            // this.CRITERIALOOKUP.push(searchCriteriaDO)
          })
          if(this.product && this.product.productId){
            this.SubmissionDataForm.get('productType').setValue(this.product.productId);
          }
          if(this.product && this.product.policyTypeCd){
            this.dataTransformService.selectedProductType = this.product.policyTypeCd;
          }
          if (this._inputDataForEdit) {
            let DO = this.commonUtilty.getDO(this._inputDataForEdit) || {}
            let selectedProductData = this.productData.filter(item => item.productId === DO.baseProductCd)
            if (this.commonUtilty.isArrayIterable(selectedProductData)) {
              this.getPlanAndPackages(selectedProductData);
              this.setPlanAndPackages(DO);
            }
          }

        }
      })
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format('DD MMM YYYY');
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  productBenefitList = [];
  productAttributeList = [];
  riderAttributeList = [];
  productRiderAssociationList = [];
  productTermAndContionsList = [];
  productExclusionsList = [];
  planList = [];
  packageList = [];
  filteredPlanOptionLookup = [];

  captureDataBasedOnProductSelection(selectedProduct) {
    this.packageList = [];
    this.planList = [];
    // this.SubmissionDataForm.get('planType').reset();
    // this.SubmissionDataForm.get('packageType').reset();
    // this.SubmissionDataForm.get('currencyType').reset();
    if (this.productData && this.productData.length && this.productData.length > 0) {
      var productSpecs = this.productData.filter(product => {
        return product.productId == selectedProduct;
      })

      if (productSpecs && productSpecs.length && productSpecs.length > 0) {
        this.productBenefitList = productSpecs[0].productBenefitList;
        this.productAttributeList = productSpecs[0].attributeList;
        this.productRiderAssociationList = productSpecs[0].productRiderAssociationList;
        this.productTermAndContionsList = productSpecs[0].productTermAndConditionList;
        this.productExclusionsList = productSpecs[0].productLoadingExclusionList;
        this.getPlanAndPackages(productSpecs)

        this.productAttributesConfig(this.productAttributeList);
        this.interactService.sendProductConfig(productSpecs);
      }
    }
  }

  getPlanAndPackages(productSpecs) {
    this.planList = [];
    this.packageList = [];
    if (Array.isArray(productSpecs) && productSpecs.length > 0) {
      if (productSpecs[0].planOptionCd) {
        let filteredPlanOptionLookup = productSpecs[0].planOptionCd.split(',');
        for (let i = 0; i < filteredPlanOptionLookup.length; i++) {
          let tempObj = {
            'lookupKey': filteredPlanOptionLookup[i],
            'lookupValue': filteredPlanOptionLookup[i]
          }
          this.planList.push(tempObj);
        }
      }

      if (productSpecs[0].productTypeCd) {
        let filteredpackageOptionLookup = productSpecs[0].productTypeCd.split(',');
        for (let i = 0; i < filteredpackageOptionLookup.length; i++) {
          let tempObj = {
            'lookupKey': filteredpackageOptionLookup[i],
            'lookupValue': filteredpackageOptionLookup[i]
          }
          this.packageList.push(tempObj);
        }
      }
    }
  }

  currencyLookup = [];
  policyTermLookup = [];
  disableSumInsuredField = false;
  productAttributesConfig(productAttributeList) {
    if (Array.isArray(productAttributeList) && productAttributeList.length > 0) {
      productAttributeList.forEach(attrObj => {
        switch (attrObj.vocabularyCd) {
          case 'CurrencyCd':
            //this.currencyLookup = [];
            var filteredCurrencyLookup = attrObj && attrObj.allowedLookupsCSV ? attrObj.allowedLookupsCSV.split(',') : null

            if (filteredCurrencyLookup && filteredCurrencyLookup.length && filteredCurrencyLookup.length == 1) {
              if(this.commonUtilty.isArrayIterable(this.currencyLookup)){
                this.currencyLookup = this.currencyLookup.filter(lookup => lookup.lookupKey === attrObj.allowedLookupsCSV)
                  let defaultCurrency = this.currencyLookup.find(item => item.lookupKey === this.newBusinessAppSettings._allowedCurrency)
                  if (defaultCurrency)
                    this.SubmissionDataForm.get('currencyType').setValue(defaultCurrency.lookupKey)
              }else{
                this.lookup$['currencyCd'].subscribe(lookup => {
                  this.currencyLookup = lookup.filter(lookup => lookup.lookupKey === attrObj.allowedLookupsCSV)
                  let defaultCurrency = this.currencyLookup.find(item => item.lookupKey === this.newBusinessAppSettings._allowedCurrency)
                  if (defaultCurrency)
                    this.SubmissionDataForm.get('currencyType').setValue(defaultCurrency.lookupKey)
                  // this.currencyLookup = cur
                })
              }
              
            } else if (filteredCurrencyLookup && filteredCurrencyLookup.length && filteredCurrencyLookup.length > 1) {
              let tempLookup = [];
              if(this.commonUtilty.isArrayIterable(this.currencyLookup)){
                console.log("subscribed currency lookup", JSON.stringify(this.currencyLookup));
                  for (let i = 0; i < filteredCurrencyLookup.length; i++) {
                    for (let j = 0; j < this.currencyLookup.length; j++) {
                      if (filteredCurrencyLookup[i] === this.currencyLookup[j].lookupKey) {
                        let tempObj = {
                          'lookupKey': this.currencyLookup[j].lookupKey,
                          'lookupValue': this.currencyLookup[j].lookupValue
                        }
                        this.currencyLookup.push(tempObj);
                      }
                    }
                  }
                  let defaultCurrency = this.currencyLookup.find(item => item.lookupKey === this.newBusinessAppSettings._allowedCurrency)
                  this.SubmissionDataForm.get('currencyType').setValue(defaultCurrency.lookupKey)
              }
              else{
                this.lookup$['currencyCd'].subscribe(lookup => {
                  console.log("subscribed currency lookup", JSON.stringify(lookup));
                  for (let i = 0; i < filteredCurrencyLookup.length; i++) {
                    for (let j = 0; j < lookup.length; j++) {
                      if (filteredCurrencyLookup[i] === lookup[j].lookupKey) {
                        let tempObj = {
                          'lookupKey': lookup[j].lookupKey,
                          'lookupValue': lookup[j].lookupValue
                        }
                        this.currencyLookup.push(tempObj);
                      }
                    }
                  }
                  let defaultCurrency = this.currencyLookup.find(item => item.lookupKey === this.newBusinessAppSettings._allowedCurrency)
                  this.SubmissionDataForm.get('currencyType').setValue(defaultCurrency.lookupKey)
                })
              }
              
            }
            break;

          case 'PolicyTerm':
            this.policyTermLookup = [];
            var filteredTermLookup = attrObj.allowedLookupsCSV ? attrObj.allowedLookupsCSV.split(',') : [];
            if (filteredTermLookup && filteredTermLookup.length && filteredTermLookup.length == 1) {
              // this.SubmissionDataForm.get('term').setValue(attrObj.allowedLookupsCSV)
            } else if (filteredTermLookup && filteredTermLookup.length && filteredTermLookup.length > 1) {
              for (let k = 0; k < filteredTermLookup.length; k++) {
                let lookupObj = {
                  'lookupKey': filteredTermLookup[k],
                  'lookupValue': filteredTermLookup[k],
                }
                this.policyTermLookup.push(lookupObj);
              }
            }

            if (this.policyTerm)
              this.SubmissionDataForm.get('term').setValue(this.policyTerm.toString());
            break;

          // case 'SumInsured':
          //   if (attrObj.configuredValue) {
          //     this.disableSumInsuredField = true;
          //     this.SubmissionDataForm.get('sumInsured').setValue(attrObj.configuredValue);
          //   }
          //   break;
        }
      })
    }
  }

  THOUSAND_SEPERATOR = ','
  DECIMAL_SEPERATOR = '.'

  onChanges(): void {
    this.SubmissionDataForm.valueChanges.subscribe(val => {
      // this.configData.ComponentMetaDataConfiguration.BasePlanComponent[1].defaultValue = this.commonUtilty.deepCopy(val.sumInsured);
      // this.configData.ComponentMetaDataConfiguration.BasePlanComponent[2].defaultValue = this.commonUtilty.deepCopy(val.term);
      this.interactService.pingForRefreshBasePlan();
      // this.interactService.sendBaseProductChangedData(val);
    });

    this.SubmissionDataForm.get('productType').valueChanges.subscribe(val => {
      //this.configData.ComponentMetaDataConfiguration.BasePlanComponent[0].defaultValue = this.commonUtilty.deepCopy(val);
      this.clearCoveragesLookup();
      this.interactService.pingForRefreshBasePlan();
      this.fetchUIMetadata(val);
      this.fetchCoverages(val);
      this.captureDataBasedOnProductSelection(val);
      // this.SubmissionDataForm.get('term').reset();
      // this.SubmissionDataForm.get('expiryDate').reset();
      // this.SubmissionDataForm.get('currencyType').reset();
    })

    this.SubmissionDataForm.get('currencyType').valueChanges.subscribe(currency => {
      if (currency) {
        this.appMetadataHandler.setCurrency(currency);
        this.interactService.pingForRefreshCoverages();

      }
    })

    this.SubmissionDataForm.get('packageType').valueChanges.subscribe(data => {
      if (data)
        this.emitPackageTypeData(data);
    })

    // this.SubmissionDataForm.get('inceptionDate').valueChanges.subscribe(val => {
    //   if (val) {
    //     console.log("commence date val", val);
    //     // val = new Date();
    //     let startDate = moment(val, 'DD MMM YYYY').add(this.SubmissionDataForm.get('term').value, 'years');
    //     // let policyExpiryDt = new Date(val.setFullYear(val.getFullYear() + this.SubmissionDataForm.get('term').value));
    //     console.log("policy expiry date", startDate);
    //     let endDate = new Date(startDate.format('DD MMM YYYY'));

    //     console.log("newDate", endDate);
    //     this.SubmissionDataForm.get('expiryDate').setValue(endDate);
    //   }
    // })

    this.SubmissionDataForm.get('term').valueChanges.subscribe(val => {
      if (val && this.SubmissionDataForm.get('inceptionDate').value) {
        let startDate = moment(this.SubmissionDataForm.get('inceptionDate').value, 'DD MMM YYYY').add(val, 'years');
        let endDate = new Date(startDate.format('DD MMM YYYY'));
        this.SubmissionDataForm.get('expiryDate').setValue(endDate);
      }
    })

    this.SubmissionDataForm.get('inceptionDate').valueChanges.subscribe(val => {
      if (val && this.SubmissionDataForm.get('inceptionDate').value) {
        //let startDate = moment(this.SubmissionDataForm.get('inceptionDate').value, 'DD MMM YYYY').add(val, 'years');
        //let endDate = new Date(startDate.format('DD MMM YYYY'));
        this.SubmissionDataForm.get('anniversaryDt').setValue(val);
      }
    })
    

    // this.SubmissionDataForm.get('expiryDate').valueChanges.subscribe(val => {
    //   // if (val && this.SubmissionDataForm.get('inceptionDate').value) {
    //   //   let startDate = moment(this.SubmissionDataForm.get('inceptionDate').value, 'DD MMM YYYY').add(val, 'years');
    //   //   let endDate = new Date(startDate.format('DD MMM YYYY'));
    //   //   this.SubmissionDataForm.get('expiryDate').setValue(endDate);
    //   // }
    //   let val1 = this.SubmissionDataForm.get('inceptionDate').value;
    //   let val2 = val
    //   let startDt = new Date(val1);
    //   let endDt = new Date(val2);
    //   let yearsDiff = endDt.getFullYear() - startDt.getFullYear();
    //   this.SubmissionDataForm.get('term').setValue(yearsDiff)
    // })
  }

  emitPackageTypeData(data) {
    this.policyPackageType.emit(data);
  }

  actionablesOnProductSelection(productCd) {
    this.productCd = productCd;
    this.fetchUIMetadata(productCd);
    this.clearCoveragesLookup();
    this.fetchCoverages(productCd);
    this.configData.ComponentMetaDataConfiguration.BasePlanComponent[0].defaultValue = this.commonUtilty.deepCopy(productCd);
    this.interactService.pingForRefreshBasePlan();
  }

  getDifferenceInDates(startDt, expiryDt) {
    var dt1 = moment(startDt, 'DD MMM YYYY');
    var dt2 = moment(expiryDt, 'DD MMM YYYY');
    var diff = dt2.diff(dt1, 'years');
    return diff;
  }

  clearCoveragesLookup() {
    if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['additionalCoveragesCd']))
      this.lookupDataService.lookupCacheMap['additionalCoveragesCd'] = [];
    if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd']))
      this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'] = [];
  }


  setPlanAndPackages(DO) {
    let basePlanData = [];
    if (DO['proposalCoverages'] && DO['proposalCoverages'].length && DO['proposalCoverages'].length > 0) {
      basePlanData = DO['proposalCoverages'].filter(item => item.planTypeCd === 'BASEPLAN')
    } else if (DO['caseCoverages'] && DO['caseCoverages'].length && DO['caseCoverages'].length > 0) {
      basePlanData = DO['caseCoverages'].filter(item => item.planTypeCd === 'BASEPLAN')
    }

    if (basePlanData && basePlanData.length && basePlanData.length > 0 && this.commonUtilty.isArrayIterable(this.planList)) {
      //if (this.planList && this.planList.length && this.planList.length > 0) {
        this.planList.forEach(planObj => {
          if (basePlanData[0].planOptionCd === planObj.lookupKey)
            this.SubmissionDataForm.get('planType').setValue(planObj.lookupKey);
        })
      //}
      if (this.packageList && this.packageList.length && this.packageList.length > 0) {
        this.packageList.forEach(packageObj => {
          //if (basePlanData[0].packageCd === packageObj.lookupKey)
          if (DO['baseProductTypeCd'] === packageObj.lookupKey)
            this.SubmissionDataForm.get('packageType').setValue(packageObj.lookupValue);
        })
      }
    }
  }

  fetchCoverages(productCd) {
    if (productCd) {
      this.workqueueService.fetchRiders(productCd)
        .subscribe(jsonResp => {
          if (jsonResp && jsonResp.length) {
            jsonResp.forEach((criteria: any) => {
              // this.coverages = [];
              // coverting to local obj, coz response from server is Array within Array
              if (criteria[2] == 'OPTIONAL') {
                let lookupObj = { lookupKey: criteria[1], lookupValue: criteria[0] }
                this.commonUtilty.addLookupDataToCache(lookupObj.lookupKey, lookupObj.lookupValue, 'additionalCoveragesCd');
              }

              if (criteria[2] == 'MANDATORY') {
                let lookupObj = { lookupKey: criteria[1], lookupValue: criteria[0] }
                this.commonUtilty.addLookupDataToCache(lookupObj.lookupKey, lookupObj.lookupValue, 'mandatoryCoveragesCd');
              }

              this.interactService.pingForRefreshCoverages()
            })
          }
        })
    }
  }

  fetchUIMetadata(productCd) {
    if (productCd) {
      this.workqueueService.fetchUIMetadata(productCd).subscribe(response => {
        console.log("metadata response", JSON.stringify(response));
        let metadataArray = response || [];
        if (this.commonUtilty.isArrayIterable(metadataArray)) {
          metadataArray.forEach(metaData => {
            if (metaData.productCd == productCd && !metaData.riderCd)
              this.policyBasicDetailsMetadata = metaData.uiConfigurations ? metaData.uiConfigurations.filter(item => item.fieldType != 'TEXT') : [];
            // else
            //   this.UIMetadataMap[metaData.riderCd] = this.commonUtilty.deepCopy(metaData.uiConfigurations);
          });

          console.log("UI Metadata Map", JSON.stringify(this.UIMetadataMap));
        }
      })
    }
  }

  emitMandatoryCoverages() {
    if (this.commonUtilty.isArrayIterable(this.productRiderAssociationList)) {
      let mandatoryCoverageList = this.productRiderAssociationList.filter(item => item.associationTypeCd === 'MANDATORY')
      this.mandatoryCoveragesEmitter.emit(mandatoryCoverageList);
    }
  }

  emitToggleRefreshBasePlanComponent() {
    this.basePlanRefreshEmitter.emit(true);
  }

  emitToggleRefreshMandatoryCoveragesComponent() {
    this.mandatoryCoveragesRefreshEmitter.emit(true);
  }

  emitToggleRefreshAdditionalCoveragesComponent() {
    this.additionalCoveragesRefreshEmitter.emit(true);
  }

  clearData() {
    this.SubmissionDataForm.get('term').reset();
    this.SubmissionDataForm.get('expiryDate').reset();
  }

  UItoServerTransform(payload, response) {
    let DO = this.commonUtilty.getDOName(payload)
    if (this.appMetadataHandler.featureFlags.enableDynamicRendering) {
      payload[DO].baseProductCd = response.componentData.productCd;
      // payload[DO].sumInsured = response.componentData.data.PolicyDetailsComponent.sumInsured;
      payload[DO].purposeOfInsuranceCd = null;
      payload[DO].baseProductFamilyCd = response.componentData.productFamilyCd;
      // payload[DO].pdfTemplateCd = this.newBusinessAppSettings.APPCONSTANTS.productFamilyCd;
      payload[DO].pdfTemplateCd = response.componentData.productFamilyCd;
      payload[DO].submissionModeCd = "PAPER"
      payload[DO].currencyCd = response.componentData.data.PolicyDetailsComponent.currencyCd;
      payload[DO].proposalReceivedDt = new Date();
      payload[DO].policyCommencementDt = new Date();
      payload[DO].proposalSignedDt = new Date();
      let expiryDt = new Date();
      let term = response.componentData.data.PolicyDetailsComponent.policyTerm
      expiryDt.setFullYear(expiryDt.getFullYear() + parseInt(term));
      payload[DO].policyExpiryDt = expiryDt;
      payload[DO].proposalEntryDt = null;
      payload[DO].policyTripDO = null;
      payload[DO].errorFl = false;
      payload[DO].policyTerm = response.componentData.data.PolicyDetailsComponent.policyTerm;
    } else {
      payload[DO].productPlanOptionCd = response.componentData.value.planType;
      payload[DO]['baseProductTypeCd'] = response.componentData.value.packageType; // packageCd
      payload[DO]['promoCd'] = response.componentData.value.campaignCode;
      payload[DO]['currencyCd'] = response.componentData.value.currencyType;
    }
    return payload
  }

  updateCoveragesComponentData(formData) {
    // this.configData.ComponentMetaDataConfiguration.BasePlanComponent[1].defaultValue = this.commonUtilty.deepCopy(formData.sumInsured);
    this.configData.ComponentMetaDataConfiguration.BasePlanComponent[2].defaultValue = this.commonUtilty.deepCopy(formData.policyTerm);
    if (formData.currencyCd) {
      this.appMetadataHandler.setCurrency(formData.currencyCd);
    }
    this.interactService.pingForRefreshBasePlan();
    this.interactService.pingForRefreshCoverages();
  }

  productChanged(){
    this.msgService.loading('Proceeding to Transaction', { nzDuration: 4000 });
    this.fetchUIMetadataAndOpenTransaction(this.SubmissionDataForm.get('productType').value);
  }

  fetchUIMetadataAndOpenTransaction(product) {
    if (product) {
      this.workqueueService.fetchUIMetadata(product).subscribe(response => {
        let metadataArray = response || [];
        this.metadataService.productBasedConfigData = response || [];
        if (this.commonUtilty.isArrayIterable(metadataArray)) {
          metadataArray.forEach(metaData => {
            if (metaData.productCd == product && !metaData.riderCd) {
              let metaDataErrorList = []
              // let metaDataErrorList = this.validationUtilService.validateMetaData(metaData.uiConfigurations)
              if (this.commonUtilty.isArrayIterable(metaDataErrorList)){
                this.msgService.error("Error in rendering coverage specific to selected product: " , product);
              }
              else{
                // write refreshing coverage logic here....
                this.interactService.pingForRefreshCoverage();
              }
            }
          });
        }
      })
    }
  }
  
  formDataChangeHandler(fieldKey){
    // let me = this;
    // me.interactService.formFieldChangeSubject(fieldKey);
    this.changedField.emit(fieldKey);
  }
  today = new Date();
  //To disable days before current day
  disabledDatePast = (current: Date): boolean =>
    differenceInCalendarDays(current, this.today) < 0;

  //To disable days after current day
  disabledDateFuture = (current: Date): boolean =>
    differenceInCalendarDays(current, this.today) > 0;
}